import { CommonModule, Location } from '@angular/common';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { RootState } from '@root/app.state';
import { selectNavigatedCustomerSpace } from '@core/core.selectors';

import { selectLastRouterPath } from '@platform/platform.selectors';
import * as RouterActions from '@platform/router.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLinkType } from '@core/common.types';
import { RouterModule } from '@angular/router';
import { BackButtonComponent } from '../back-button/back-button.component';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, BackButtonComponent],
})
export class PageHeaderComponent implements OnInit {
  @Input() showBackButton = true;
  @Input() usePreviousPathIfAvailable = false;
  @Input() backLink: string[] = ['/home', 'customer-spaces'];
  @Input() showCustomerSpaceName!: boolean;
  @Input() hasImage!: boolean;
  @Input() legalEntityName = '';
  @Input() legalEntityLink: RouterLinkType = '';

  public customerSpaceLink!: string[];
  public customerSpaceName!: string;
  private previousPath!: string;

  constructor(
    private store$: Store<RootState>,
    private location: Location,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.store$
      .pipe(
        select(selectNavigatedCustomerSpace),
        filter((state) => !!state.data),
        map((state) => state.data),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((x) => {
        this.customerSpaceLink = ['/customer-spaces', x.id];
        this.customerSpaceName = x.name;
      });

    this.store$.pipe(select(selectLastRouterPath), takeUntilDestroyed(this.destroyRef)).subscribe((x) => {
      this.previousPath = x!;
    });
  }

  navigateBack() {
    const previousPath = this.previousPath;
    this.store$.dispatch(RouterActions.clearPath());

    if (this.usePreviousPathIfAvailable && previousPath) {
      const currentPath = this.location.path();

      if (currentPath.localeCompare(previousPath) !== 0) {
        this.store$.dispatch(RouterActions.go({ path: [previousPath] }));
        return;
      }
    }

    this.store$.dispatch(RouterActions.go({ path: this.backLink }));
  }
}
